import { render, staticRenderFns } from "./SourceOfFundFilesTable.vue?vue&type=template&id=7570f1c8"
import script from "./SourceOfFundFilesTable.vue?vue&type=script&lang=js"
export * from "./SourceOfFundFilesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports